interface YouTubeIconProps {
  className?: string;
}

export function YouTubeIcon({ className = "w-6 h-4" }: YouTubeIconProps) {
  return (
    <svg
      width="23"
      height="17"
      viewBox="0 0 23 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.498 2.75593C22.3656 2.27179 22.108 1.83044 21.7506 1.47573C21.3932 1.12103 20.9485 0.865311 20.4607 0.733995C18.6746 0.25 11.4856 0.25 11.4856 0.25C11.4856 0.25 4.29633 0.264267 2.50988 0.748261C2.02206 0.879578 1.57735 1.13529 1.21995 1.49C0.862551 1.84471 0.604892 2.28606 0.472578 2.7702C0 4.54318 0 8.25 0 8.25C0 8.25 0 11.9568 0.487312 13.7441C0.619626 14.2282 0.877285 14.6696 1.23469 15.0243C1.59209 15.379 2.03679 15.6347 2.52461 15.766C4.3107 16.25 11.5 16.25 11.5 16.25C11.5 16.25 18.6893 16.25 20.4757 15.7664C20.9636 15.635 21.4083 15.3793 21.7657 15.0246C22.1231 14.6699 22.3807 14.2286 22.513 13.7444C23 11.9714 23 8.25 23 8.25C23 8.25 22.9856 4.54318 22.498 2.75593Z"
        fill="#FF0000"
      />
      <path
        d="M9.19712 11.6783L15.161 8.25L9.19677 4.82173L9.19712 11.6783Z"
        fill="white"
      />
    </svg>
  );
}
